export class PadStartValueConverter {
    toView(value, format) {
        return value.toString().padStart(...format.split(","));
    }
}
